var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChakra(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 118.25,
    height: 28,
    role: "img",
    "aria-label": "CHAKRA UI",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CHAKRA UI") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118.25,
    height: 28,
    fill: "#4ed1c5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Verdana,Geneva,DejaVu Sans,sans-serif",
    textRendering: "geometricPrecision",
    fontSize: 100
  }, /*#__PURE__*/React.createElement("image", {
    x: 9,
    y: 7,
    width: 14,
    height: 14,
    xlinkHref: "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJ3aGl0ZSIgcm9sZT0iaW1nIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHRpdGxlPkNoYWtyYSBVSTwvdGl0bGU+PHBhdGggZD0iTTEyIDBDNS4zNTIgMCAwIDUuMzUyIDAgMTJzNS4zNTIgMTIgMTIgMTIgMTItNS4zNTIgMTItMTJTMTguNjQ4IDAgMTIgMHptMi44IDQuMzMzYy4xMy0uMDA0LjI0OC4xMzYuMTcxLjI3OGwtMy4wNDQgNS41OGEuMTg3LjE4NyAwIDAwLjE2NC4yNzZoNS4yNmMuMTcgMCAuMjUyLjIwNy4xMjguMzIzbC05LjIyIDguNjA1Yy0uMTY1LjE1NC0uNDEtLjA2My0uMjc4LS4yNDZsNC4zNjQtNi4wMjFhLjE4Ny4xODcgMCAwMC0uMTUxLS4yOTZINi42MjdhLjE4Ny4xODcgMCAwMS0uMTMxLS4zMmw4LjE4LTguMTIzYS4xODIuMTgyIDAgMDEuMTI1LS4wNTZ6Ii8+PC9zdmc+"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "scale(.1)",
    x: 691.25,
    y: 175,
    textLength: 742.5,
    fill: "#fff",
    fontWeight: "bold"
  }, "CHAKRA UI"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChakra);
export default __webpack_public_path__ + "static/media/chakra.3a9ac4c541b9fc9e656d1d1c8fcab275.svg";
export { ForwardRef as ReactComponent };